import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ScrollToTop } from "@/components/ScrollToTop";
import { RouteChangeTracker } from "@/components/RouteChangeTracker";
import Index from "./pages/Index";
import Services from "./pages/Services";
import { WellPumpRepair, WellPumpInstallation, GrinderPumpRepair, SewagePumpSystems, WaterFiltration, EmergencyPumpService, HydroFracking } from "./pages/ServicePages";
import ServiceArea from "./pages/ServiceArea";
import Reviews from "./pages/Reviews";
import Resources from "./pages/Resources";
import ResourceArticle from "./pages/ResourceArticle";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import GeoServicePage from "./pages/GeoServicePage";
import ThankYou from "./pages/ThankYou";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import Unsubscribe from "./pages/Unsubscribe";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <RouteChangeTracker />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/well-pump-repair" element={<WellPumpRepair />} />
            <Route path="/services/well-pump-installation" element={<WellPumpInstallation />} />
            <Route path="/services/grinder-pump-repair" element={<GrinderPumpRepair />} />
            <Route path="/services/sewage-pump-systems" element={<SewagePumpSystems />} />
            <Route path="/services/water-filtration" element={<WaterFiltration />} />
            <Route path="/services/emergency-pump-service" element={<EmergencyPumpService />} />
            <Route path="/services/hydro-fracking" element={<HydroFracking />} />
            <Route path="/service-area" element={<ServiceArea />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:slug" element={<ResourceArticle />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="/:slug" element={<GeoServicePage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </HelmetProvider>
  </QueryClientProvider>
);

export default App;
